export default __webpack_public_path__ + "static/media/Bandit's Armbands of a Hundred Eyes.a5b5f281.jpg";